import { defineMigrations } from "@supersig/store";
/** @public */ export const lottieNodeProps = {};
/** @internal */ export const lottieNodeMigrations = defineMigrations({});
export const LottieNodeInfo = {
    migrations: lottieNodeMigrations,
    props: lottieNodeProps,
    meta: {}
};
